import jobs from './jobs';
import personalAccessTokens from './personal-access-tokens';
import profile from './profile.vue';

export default {
  profile,
  jobs,
  personalAccessTokens,
};
